import { toast } from 'react-toastify';
const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

export const formatDate = (date, format = 103) => {
    let stringFormat = ''
    switch  (format) {
        case 23:
            stringFormat = [
                date.getFullYear(),                
                padTo2Digits(date.getMonth() + 1),
                padTo2Digits(date.getDate())
            ].join('-');
            break;
        case 103:
            stringFormat = [
                padTo2Digits(date.getDate()),
                padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
            break;
        default:
            console.error('Ingreso un formato no valido mapeado')
    }

    return stringFormat;
}

export const primeraLetraMayusculaOracion = (string) => {
    if (!string) return '';

    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}


export const notify = (title, type, options = {}) => {
    toast[type](title, {
        position: options.position ?? "top-right",
        autoClose: options.autoClose ?? 5000,
        hideProgressBar: options.hideProgressBar ?? false,
        closeOnClick: options.closeOnClick ?? true,
        pauseOnHover: options.pauseOnHover ?? true,
        draggable: true,
        progress: undefined,
    });
}

export const obtenerFechaHora = () => {
    const fechaActual = new Date();
    const dia = String(fechaActual.getDate()).padStart(2, '0');
    const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
    const anio = fechaActual.getFullYear();
    const horas = String(fechaActual.getHours()).padStart(2, '0');
    const minutos = String(fechaActual.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${anio} ${horas}:${minutos}`
}

export const parseFechaHoraDate = (fecha) => {
    const fechaSinHora = fecha.split(' ')[0]
    const [ dia, mes, anio ] = fechaSinHora.split('/');
    return new Date(anio,(mes - 1),dia);
}

export const parseFechaDate = (fecha) => {
    const [ dia, mes, anio ] = fecha.split('/');
    return new Date(anio,(mes - 1),dia);
}

export const soloCelular = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{8}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloNumero = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{20}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDNI = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{7}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDecimal = (e, elemento) => {
    const key = e.keyCode ? e.keyCode : e.which

    if (key === 8) return true
    
    if (key > 47 && key < 58) {
        if (elemento.value === "") return true
        const regexp = /.[0-9]{9}$/

        if(!(regexp.test(elemento.value))) {
            return true
        }
    }

    if (key === 46) {
        if (elemento.value === "") return false
        const regexp = /^[0-9]+$/
        console.log("s ", regexp.test(elemento.value))
        if (regexp.test(elemento.value)) {
            return true
        }
    }
    
    e.preventDefault()
}

export const formatState = (codState) => {  
    let className 
    let color 
    if ([1].includes(codState)) color = 'yellow'
    else if ([2].includes(codState)) color = 'green'
    else if ([3].includes(codState)) color = 'red'
    className = `cursor-pointer bg-${color}-600 px-2 py-[2px] rounded uppercase text-[11px] font-bold`
    return className;
}


export const primeraLetraMayuscula = (string) => {
    var str = string;

    str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });

    return str; 
}

export const todoMayuscula = (string)=> {
    var str = string;
    str = str.toUpperCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
    return str;
}

export const quitarTildes = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const obtenerEstado = (codEstado,nomEstado) => {
    const obtenerColor = (codigo) => {
        switch(codigo){
            case 9: //Pendiente
                return 'bg-yellow-500'
                // break;
            case 48: //En proceso
                return 'bg-green-500'
                // break;
            case 51: //Finalizado
                return 'bg-red-500'
                // break;
            default:
                return 'bg-cyan-500'
        }
    }
    return <span className={`${obtenerColor(codEstado)} rounded px-2 text-xs py-1 whitespace-nowrap`}>{ primeraLetraMayuscula(nomEstado)}</span>
}

export const formatearFechaHora = (fechaHora) => {
    if (!fechaHora) return null; 
    const [ fecha, horas ] = fechaHora.split(" ")
    const [ dia, mes, anio ] = fecha.split("/");
    const [ hora, minuto ] = horas.split(':')
    return new Date(anio, mes -1, dia, hora, minuto)
}

const extensionesImagen = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'tiff', 'webp', 'ico', 'psd', 'ai', 'raw', 'xcf', 'eps'];
const extensionesDocumento = ['xlsx','xls','xlsb','csv','docx','docb','pdf','pptm','pptx','txt'];

export const validarExtensionImagen = (extension) => {
    const extensionMinusculas = extension.toLowerCase();
    return extensionesImagen.includes(extensionMinusculas);
}

export const validarExtensionDocumento = (extension) => {
    
    const extensionMinusculas = extension.toLowerCase();
    return extensionesDocumento.includes(extensionMinusculas);
}

export const obtenerExtension = (archivo) =>{
    const partes = archivo.split('.');
    if (partes.length >= 2) {
        return partes[partes.length - 1];
    } else {
        return 'Sin extension'
    }
}

export const eliminarTodasLasExtensiones = (cadena) =>{
    const extensionesPermitidas = /\.(png|jpg|jpeg|gif|docx|xls|pdf|txt|pptx)/ig;
    return ((cadena.replace(extensionesPermitidas, '')).replaceAll('.','')).replaceAll(' ','_');
}

export const descargarArchivoUrl = (url) => {
    const nuevaUrl = url.replace('verImagen','descargarArchivo').replace('NombreImagen','NombreArchivo');
    return  nuevaUrl + '&Extension=png'
}

export const obtenerHoraActual = (incrementoMinutos = 0) => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + incrementoMinutos)
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // Asegura el formato de 24 horas
    };
    return now.toLocaleTimeString('en-GB', options); 
}

export const transformarArchivoUrl = async (archivos, nomCarpeta, nomSubCarpeta) => {
    const urlResponse =  archivos.map(async (data) => {
        return await enviarMinio(data, nomCarpeta, nomSubCarpeta);
    })
    const urlArchivoJson = await Promise.all(urlResponse);
    return urlArchivoJson
}

const promesasPendientes = {};
export const enviarMinio = async (file, nomCarpeta, nomSubCarpeta) =>{
    let carpeta = nomCarpeta ? nomCarpeta : 'xbest';
    let subCarpeta = nomSubCarpeta ? nomSubCarpeta + '/' : 'pgi/';
    if (promesasPendientes[file.identificador]) {
        await promesasPendientes[file.identificador];
    }
    const formData = new FormData();
    const blob = file.slice(0, file.size , 'aplication/json');
    const nuevoArchivo = new File([blob],file.nombre,{ type: 'aplication/json' });
    formData.append('archivo',nuevoArchivo);
    const queryParameters = {
        NombreCarpeta: carpeta,
        NombreSubCarpeta : subCarpeta,
        nombreArchivo: eliminarTodasLasExtensiones(file.nombre)
    }
    // const queryParameters = {
    //     bucket: carpeta,
    //     carpeta: subCarpeta,
    //     nombre: eliminarTodasLasExtensiones(file.nombre)
    // }
    // const urlEnvioMinio = 'https://miniowebapi.prometheusperu.com/subirFoto/?bucket=prometheus&carpeta=smarthome%2Fproductos&nombre=producto1001';
    // const urlVerImagen = `https://miniowebapi.prometheusperu.com/verImagen?bucket=${carpeta}&carpeta=${subCarpeta}&nombre=${eliminarTodasLasExtensiones(file.nombre)}`;
    // const urlDescargar = `https://miniowebapi.prometheusperu.com/descargarArchivo?bucket=${carpeta}&carpeta=${subCarpeta}&nombre=${eliminarTodasLasExtensiones(file.nombre)}&Extension=${obtenerExtension(file.nombre)}`;
    const urlEnvioMinio = `https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?${new URLSearchParams(queryParameters)}`;
    const urlVerImagen = `https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=xbest&NombreImagen=pgi%2F${eliminarTodasLasExtensiones(file.nombre)}`
    const urlDescargar = `https://miniowebapi.abexacloud.com/api/Archivo/descargarArchivo?NombreCarpeta=xbest&NombreArchivo=pgi%2F${eliminarTodasLasExtensiones(file.nombre)}&Extension=${obtenerExtension(file.nombre)}`
    promesasPendientes[file.identificador] = fetch(urlEnvioMinio,{
        method:'POST',
        body: formData
    })
    .then(res => res.json())
    .then(response => {
        !response.isValid && notify(response.content, 'error');
        if(response.isValid){
            return {
                urlArchivo: validarExtensionImagen(obtenerExtension(file.nombre)) ? urlVerImagen : urlDescargar,
                nombreArchivo: eliminarTodasLasExtensiones(file.nombre),
                extensionArchivo : obtenerExtension(file.nombre),
                codArchivoTipo: validarExtensionImagen(obtenerExtension(file.nombre)) ? 2 : 1 
            }
        }
    })
    .catch(e => () => {
        notify(`Ocurrió un error: ${e}` ,'error')
    })
    // despacho({tipo: 'Agregar', carga: await promesasPendientes[file.identificador]})
    const urlReturn = await  promesasPendientes[file.identificador];
    delete promesasPendientes[file.identificador];
    return urlReturn;

}

export const validarUrlVerImagen = (urlImagen) => {
    if(urlImagen.includes('&Extension=')){
        return urlImagen.replace('descargarArchivo','verImagen').replace('NombreArchivo','NombreImagen').split('&Extension')[0];
    }
    else{
        return urlImagen
    }
}

export const transdormarUrlDescargar = (urlImagen) => {
    if(urlImagen.includes('&Extension=')){
        return urlImagen
    }
    else{
        return urlImagen.replace('verImagen','descargarArchivo').replace('NombreImagen','NombreArchivo') + '&Extension=png';
    }
}

export const convertirBase64  = async (valor) => {
    const valorJson = JSON.stringify(valor);
    const encoder = new TextEncoder();
    const byteArray = encoder.encode(valorJson);
    const parseString = String.fromCharCode(...byteArray);
    return btoa(parseString)
}

export const calcularHorasTranscurridas = (tiempoActividadSegundos,fechaUltimaPausa)=> {
    if (tiempoActividadSegundos === '') {
        return ' ';
    }

    const convertirFechaHora = (fechaHora) => {
        const [fecha, hora] = fechaHora.split(' ');
        const [dia, mes, anio] = fecha.split('/').map(Number);

        // Crear un objeto Date válido para JavaScript
        return new Date(anio, mes - 1, dia, ...hora.split(':').map(Number));
    }
    const fechaHoraUltimaPausa = fechaUltimaPausa !== '' ? convertirFechaHora(fechaUltimaPausa) : 0
    const fechaHoraActual = new Date();
    const diferenciaEnSegundos = fechaHoraUltimaPausa !== 0 ? (Math.max(0, Math.floor((fechaHoraActual - fechaHoraUltimaPausa)/1000))) : fechaHoraActual.getSeconds();
    const totalSegundos = diferenciaEnSegundos + tiempoActividadSegundos;
    // const totalSegundos = Math.max(0, Math.floor(totalMilisegundos / 1000));

    // Calcular horas, minutos y segundos
    const horas = Math.floor(totalSegundos / 3600); // Usar % 24 para mantener en formato 24 horas
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;

    // Formatear cada valor con dos dígitos
    return [horas, minutos, segundos]
        .map((unidad) => String(unidad).padStart(2, '0'))
        .join(':');    
}

export const copiarTexto = async (texto) => {
    try
    {
        notify('Texto copiado en el portapapeles','success')
        navigator.clipboard.writeText(texto)
    }
    catch(e)
    {
        console.log('Error al copiar: ',e)
        notify('No se pudo realizar el copiado','error')
    }
}

export const pintarFila = (elemento) => {
    const fila = elemento.closest('tr')
    const filaConClass = fila.classList.contains('seleccion')
    Array.from(fila.parentNode.children).forEach(tr => {
        tr.style.background = ''
        tr.classList.remove('seleccion')
        if(filaConClass){
            tr.style.background = ''
        }
        else{
            if(fila == tr){
                tr.classList.add('seleccion')
                fila.style.background = '#3f6f95'
            }
        }
    })
}

export const agregarDias = (cantidadDia) => {
    const fechaActual = new Date();
    fechaActual.setDate(fechaActual.getDate() + cantidadDia);
    return formatDate(fechaActual);
}

export const convertirSegundosAFormatoHr = (segundos) => {
    let horas = Math.floor(segundos / 3600);
    let minutos = Math.floor((segundos % 3600) / 60);
    let segs = segundos % 60;
    
    // Asegura que siempre tenga 2 dígitos (agrega cero a la izquierda si es necesario)
    horas = horas.toString().padStart(2, '0');
    minutos = minutos.toString().padStart(2, '0');
    segs = segs.toString().padStart(2, '0');
    
    return `${horas}:${minutos}:${segs}`;
}

export const convertirFormatoDias = (cantidadDias) => {
    if (cantidadDias <= 0) { return "" }

    let anios = Math.floor(cantidadDias / 365);
    let meses = Math.floor((cantidadDias % 365) / 30);
    let dias = cantidadDias % 30;

    let resultado = "";

    if (anios > 0) {
        resultado += anios + (anios === 1 ? " año" : " años");
    }

    if (meses > 0) {
        resultado += (resultado !== "" ? ", " : "") + meses + (meses === 1 ? " mes" : " meses");
    }

    if (dias > 0) {
        resultado += (resultado !== "" ? " y " : "") + dias + (dias === 1 ? " día" : " días");
    }

    return resultado;
}

export const transformarArchivo = async (file, esUrl, envioArchivo ) => {
    const fechaActual = new Date();
    const fechaHoraActual = fechaHoraActualArchivo();
    const identificador = fechaActual.getTime() + file.lastModified;
    file.identificador = identificador;
    file.nombre = `inc_pgi_${identificador}.${obtenerExtension(file.name)}`;
    file.esUrl = esUrl;
    file.extension = obtenerExtension(file.name);
    envioArchivo({tipo: 'Agregar', carga: [file] })
}

export const seleccionarArchivo = (event, envioArchivo, tipoArchivo, esBloqueo) => {
    event.preventDefault();
    if(esBloqueo){return}
    if(event.target.files.length > 0){
        const archivos = event.target.files;
        for(let i = 0; i < archivos.length; i++){
            if(tipoArchivo === 'image'){
                if(event.target.files[i].type.indexOf(tipoArchivo) === 0){
                    transformarArchivo(event.target.files[i], 0,envioArchivo);
                }
                else{
                    notify('Sólo se aceptan imágenes', 'warning')
                }
            }
            else{
                if(event.target.files[i].type.indexOf('image') !== 0){
                    transformarArchivo(event.target.files[i], 0,envioArchivo);
                }
                else{
                    notify('Sólo se aceptan documentos','warning')
                }
            }
        }
    }

    
}

export const fechaHoraActualArchivo = () => {
    const fechaHoraActual = new Date();
    const fechaActual = fechaHoraActual.toLocaleDateString();
    const horaActual = fechaHoraActual.toLocaleTimeString();
    console.log('fechaActual',fechaActual)
    console.log('horaActual',horaActual)
    const respuesta = `${fechaActual.replaceAll('/','_')}_${horaActual.replaceAll(':','_')}`;
    return respuesta;
}

export const eventDrop = (event, envioArchivo, tipoArchivo, estadoArrastrar, esBloqueo) => { //Evento para soltar la imagen
    if(esBloqueo){return}
    event.preventDefault();
    if(event.dataTransfer.files.length > 0){
        const archivos = event.dataTransfer.files;
        for(let i = 0; i < archivos.length; i++){
            if(tipoArchivo === 'image'){
                if(event.dataTransfer.files[i].type.indexOf(tipoArchivo) === 0){
                    transformarArchivo(event.dataTransfer.files[i], 0, envioArchivo);
                }
                else{
                    notify('Sólo se aceptan imágenes','warning')
                }

            }
            else{
                if(event.dataTransfer.files[i].type.indexOf('image') !== 0){
                    transformarArchivo(event.dataTransfer.files[i], 0, envioArchivo);
                }
                else{
                    notify('Sólo se aceptan documentos','warning')
                }
            }
        }
    }
    event.stopPropagation();
    estadoArrastrar(false)
}

export const eventDrag = (event, estadoArrastrar, esBloqueo) => { // Evento para arrastrar una imagen
    if(esBloqueo){return}
    event.preventDefault();
    estadoArrastrar(true);
    event.stopPropagation();
}

export const eventDragLeave = (estadoArrastrar) => { // Cuando un elemento arrastrable se mueve fuera de un objetivo de caída
    estadoArrastrar(false);
}

export const eventPaste = (event, envioArchivo, tipoArchivo, esBloqueo) => {
    event.preventDefault();
    if(esBloqueo){return}
    if(event.clipboardData.files.length > 0){
        const archivos = event.clipboardData.files;
        for(let i = 0; i < archivos.length; i++){
            if(tipoArchivo === 'image'){
                if(event.clipboardData.files[i].type.indexOf(tipoArchivo) === 0){
                    transformarArchivo(event.clipboardData.files[i], 0, envioArchivo)
                }
                else{
                    notify('Sólo se aceptan imágenes','warning')
                }
                
            }
            else{
                if(event.clipboardData.files[i].type.indexOf('image') !== 0){
                    transformarArchivo(event.clipboardData.files[i], 0, envioArchivo)
                }
                else{
                    notify('Sólo se aceptan documentos','warning')
                }
            }
        }
    }
}